import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const useNavLinkStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      alignItems: "center",
    },
    link: {
      fontWeight: "bold",
      color: theme.palette.common.white,
      fontSize: "14px",
      lineHeight: "17px",
      "&~&": {
        marginLeft: "32px",
      },
    },
  }),
);
